<template>
    <v-expansion-panel>
        <v-expansion-panel-header hide-actions>
            <template v-slot:default="{ open }">
                <div class="d-flex align-center">
                    <div class="text-subtitle-1 font-weight-bold">Данные по акту на отключение / подключение</div>
                    <v-icon v-if="open">arrow_drop_up</v-icon>
                    <v-icon v-if="!open">arrow_drop_down</v-icon>
                </div>
            </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content eager>
            <div class="pb-4">
                <v-row>
                    <v-col cols="4" class="shallowGray--text">ФИО Инженера</v-col>
                    <v-col class="black--text">{{ infoCreate.engineer_name }}</v-col>
                </v-row>
            </div>
            <div>
                <v-row>
                    <v-col cols="4">
                        <PreTrialDatePicker label="Дата создания акта" :future_disabled="true" required :date.sync="form.act_date" />
                    </v-col>
                </v-row>
                <!-- <v-row v-if="!isContract">
                    <v-col>
                        <v-select
                            :attach="true"
                            hide-details
                            outlined
                            color="primaryDark"
                            label="Контролер"
                            v-model="form.inspector_rid"
                            :items="inspectors"
                            item-text="inspector_name"
                            item-value="record_id"
                        />
                    </v-col>
                </v-row> -->
                <v-row>
                    <v-col>
                        <v-text-field
                            outlined
                            color="primaryDark"
                            v-model="form.comment"
                            label="Комментарий"
                            placeholder="Введите комментарий"
                            :rules="isContract ? [] : [validationRules.required]"
                            validate-on-blur
                        />
                    </v-col>
                </v-row>
            </div>
        </v-expansion-panel-content>
        <v-divider color="gray" />
    </v-expansion-panel>
</template>
<script>
import PreTrialDatePicker from '@/components/pre-trial-notices/PreTrialDatePicker.vue';
import { validationRules } from '@/utils/validationRules';
import { mapGetters } from 'vuex';

export default {
    name: 'CreateInfoAct',
    components: { PreTrialDatePicker },
    props: ['value', 'infoCreate', 'isContract'],
    computed: {
        ...mapGetters('refs', ['getInspectorsList']),
        validationRules() {
            return validationRules;
        },
        form: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        inspectors() {
            return this.getInspectorsList;
        }
    }
};
</script>

<style scoped></style>
